export default __webpack_public_path__ + "static/media/logout.997eab43.svg";